import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=a8bb01d0&scoped=true"
import script from "@/views/Settings/Tags/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Tags/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Tags/create-dialog.scss?vue&type=style&index=0&id=a8bb01d0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bb01d0",
  null
  
)

export default component.exports